import {
  addHtmlElementClass,
  addHtmlElementEventListener,
  enableHtmlElement, isValidEmail,
  removeHtmlElementClass,
  renderWebComponent, sanitize,
  selectHtmlElement,
  string2obj,
  veryHighDebouncedFunction,
  veryVeryHighDebouncedFunction,
  customToString,
  setHtmlElementValue,
  checkHtmlElement
} from "../../../utils/utils";
import I18n from 'i18n.js.erb';
import commonStyles from '../../styles/web-components.common.css';
import toggleStyles from '../../styles/toggle.css';
import submissionListsStyles from '../../styles/submission-lists.css';
import { EventBusComponent } from "../EventBusComponent";


export class SubmissionListHeaderComponent extends HTMLElement {
  props = {};

  showMiddlemanPrices = true;

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
  }

  connectedCallback() {
    addHtmlElementEventListener(this.shadowRoot, 'title', 'input', (e) => veryVeryHighDebouncedFunction(this.updateSubmissionList, ['title', e.target.value]))
    addHtmlElementEventListener(this.shadowRoot, 'owner_email', 'input', (e) => veryHighDebouncedFunction(this.updateSubmissionList, ['owner_email', e.target.value]))
    addHtmlElementEventListener(this.shadowRoot, 'grader_company_id', 'change', (e) => this.eventBus.publish('changed-grader-company', this.props.graderCompanies.filter(company => company.id == e.target.value)[0]))
    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => this.updateSubmissionListState(submissionList));
    addHtmlElementEventListener(this.shadowRoot, 'change_price_rendering_btn', 'change', () => this.handleChangeShowPrice())
  }


  // Funzione che aggiorna lo stato corrente della submission list quando gli altri componenti segnalano tale evento sull'eventBus
  updateSubmissionListState(submissionList) {
    this.props.submissionList = { ...submissionList};
    this.enablingMiddlemanUtilities();
  }

  
  // Funzione che abilita / disabilità sull'header le funzionalità adibite ai soli aggregatori
  enablingMiddlemanUtilities() {
    if (!this.props.submissionList.is_middleman_for_company) {
      enableHtmlElement(this.shadowRoot, 'owner_email', false)
      addHtmlElementClass(this.shadowRoot, 'change_price_rendering_container', 'd-none')
    }
    else {
      enableHtmlElement(this.shadowRoot, 'owner_email', true)
      removeHtmlElementClass(this.shadowRoot, 'change_price_rendering_container', 'd-none')
    }
    setHtmlElementValue(this.shadowRoot, 'owner_email', customToString(this.props.submissionList.owner_email))
  }


  // Funzione che esegue l'update tramite richiesta http al server di determinati parametri della submission list,
  // quali ad esempio il titolo, le note, ecc.
  updateSubmissionList = (key, value) => {
    const sanitizedValue = key === 'owner_email' ? sanitize(value).trim() : sanitize(value);
    if (key === 'owner_email' && sanitizedValue && !isValidEmail(sanitizedValue)) {
        removeHtmlElementClass(this.shadowRoot, 'invalidUserEmailMsg', 'd-none');
    }
    else if (key) {
      addHtmlElementClass(this.shadowRoot, 'invalidUserEmailMsg', 'd-none');

      const url = `/submission_lists/${this.props.submissionList.id}`;

      const body = {}
      body[key] = sanitizedValue;
      this.props.submissionList[key] = sanitizedValue;

      fetch(url + ".json", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json();
        })
        .then((submissionList) => {
          this.eventBus.publish('updated-submission-list-state', submissionList);

          if (!submissionList.resetted_email)
            this.eventBus.publish('render-new-success-flash-message', null);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          this.eventBus.publish('render-modal', {error: true});
        });
    }
  }


  // Funzione che gestisce il click sul bottone che permette all'aggregatore di renderizzare sull'interfaccia grafica
  // solamente i prezzi rivolti al cliente finale o anche i prezzi a lui dedicati
  handleChangeShowPrice () {
    this.showMiddlemanPrices = !this.showMiddlemanPrices;
    this.eventBus.publish('changed-middleman-price-rendering', this.showMiddlemanPrices);
  }



  render() {
    const html = `    
      <div class="row d-block justify-content-center bg-aig-gradient w-100 m-0 color-white py-4 border-bottom-radius-20px">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10 text-center">
            <h2><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.submissionListId')}</b></h2>
          </div>
          <div class="col-1"></div>
        </div>
        
        <div class="row justify-content-start mt-3">
          <div class="col-1 col-lg-2 col-xl-3"></div>
          
          <div class="col-10 col-lg-8 col-xl-6 pl-0">
            ${
              this.props.graderCompanies.length > 1 ?`
                <div class="mb-4">
                  <label class="mb-0">
                    <h6>
                      <b>
                        ${I18n.t('js.editSubmissionListPage.webComponent.draft.graderCompany')}
                      </b>
                    </h6>
                  </label>
                  
                  <select 
                    class="form-control submission-list-header-input submission-list-small-input submission-list-grader-company-input w-100"
                    name="grader_company_id" 
                    id="grader_company_id"
                  >
                    ${this.props.graderCompanies.map((company) =>
                      `<option value=${company.id} id="grader_company_${company.id}" class="color-black">
                         ${company.name}
                      </option>`
                    ).join('')}
                  </select>
                </div>`
              :
                ``
            }
            
            ${
              this.props.isMiddleman ? `
                <div class="mb-4">
                  <label class="mb-0">
                    <h6>
                      <b>
                        ${I18n.t('js.editSubmissionListPage.webComponent.draft.userOwner')}
                        <small class="font-size-14px">${I18n.t('js.editSubmissionListPage.webComponent.draft.userOwnerExplanation')}</small>
                      </b>
                    </h6>
                  </label>
                  
                  <input
                    type="text"
                    class="form-control submission-list-header-input submission-list-small-input w-100"
                    name="owner_email"
                    id="owner_email"
                    placeholder="${I18n.t('js.editSubmissionListPage.webComponent.draft.userOwnerPlaceholder')}"
                    value="${customToString(this.props.submissionList.owner_email)}"
                    autocomplete="off"
                  />
                  
                  <div class="text-left d-none mt-2" id="invalidUserEmailMsg">
                    <i>${I18n.t('js.editSubmissionListPage.webComponent.draft.userEmailInvalid')}</i>
                  </div>
                </div>`
              :
                ``
            }
            
            <div>
              <input
                type="text"
                class="form-control submission-list-header-input submission-list-small-input w-100"
                name="title"
                id="title"
                maxlength="50"
                placeholder="${I18n.t('js.editSubmissionListPage.webComponent.draft.submissionListTitlePlaceholder')}"
                value="${this.props.submissionList.title ? this.props.submissionList.title : ''}"
                autocomplete="off"
              />
            </div>
          </div>
          
          <div class="col-1 col-lg-2 col-xl-3"></div>
        </div>
        
        <div class="row" id="change_price_rendering_container">
          <div class="col-12 text-right d-flex justify-content-end pt-3 pl-4 pr-5">
            <div class="d-block my-0">
              <p class="my-0" id="slider-label">
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.middlemanPricesCompact').toUpperCase()}
              </p>
              <label class="switch">
                <input type="checkbox" id="change_price_rendering_btn">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, toggleStyles, submissionListsStyles]);
    this.enablingMiddlemanUtilities();
    checkHtmlElement(this.shadowRoot, 'change_price_rendering_btn', this.showMiddlemanPrices);

    setTimeout(() => selectHtmlElement(this.shadowRoot, `grader_company_${this.props.submissionList.grader_company_id}`, 'selected'), 1)
  }
}

window.customElements.define("submission-list-header-component", SubmissionListHeaderComponent);